/* eslint-disable react/no-multi-comp */
import React from 'react'
import { FormattedMessage } from 'react-intl'
import moment from 'moment'
import {
    getCustomDateTime,
    getTodayTime,
    getYesterdayTime,
    isTodayDay,
    isYesterdayDay,
} from 'helpers/datetime'

export const ELO_LEADERBOARD_TITLE = (
    <FormattedMessage
        id='leaderboard.title'
        defaultMessage='Рейтинг кланов по Эло'
    />
)

export const ELO_LEADERBOARD_UPDATE_RATE_MESSAGE = recalculationPeriod => (
    <FormattedMessage
        id='UpdateRatingTooltip.title'
        defaultMessage='Данные обновляются раз в {recalculationPeriod} мин.'
        values={{ recalculationPeriod }}
    />
)

export const CLICK_TO_OPEN_LEADERBOARD = (
    <FormattedMessage
        id="ActiveDivisionClanList.message"
        defaultMessage='Нажмите, чтобы перейти к списку кланов этого дивизиона.'
    />
)

export const ELO_LEADERBOARD_DISABLED_BATTLE_MODE_FILTER_FOOTER = (
    <FormattedMessage
        id="DisabledDivisionClanList.message"
        defaultMessage='Список кланов этого дивизиона временно недоступен.'
    />
)

export const ELO_LEADERBOARD_UPDATED_DATE_MESSAGE = updateDate => {
    updateDate = moment(updateDate)

    if (isTodayDay(updateDate)) {
        updateDate = getTodayTime(updateDate)
    } else if (isYesterdayDay(updateDate)) {
        updateDate = getYesterdayTime(updateDate)
    } else {
        updateDate = getCustomDateTime(updateDate)
    }

    return (
        <FormattedMessage
            id='UpdatedRatingTooltip.date'
            defaultMessage='Обновлено {updateDate}'
            values={{ updateDate }}
        />
    )
}

export const ELO_LEADERBOARD_UPDATE = (
    <FormattedMessage
        id="leaderboard.update"
        defaultMessage='Обновить рейтинг'
    />
)



// WEBPACK FOOTER //
// ./containers/EloLeaderboard/constants.jsx